import { render, staticRenderFns } from "./RoundsList.vue?vue&type=template&id=4febe3f4"
import script from "./RoundsList.vue?vue&type=script&lang=js"
export * from "./RoundsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports